<script>
export default {
	methods: {
		getAge(dateString) {
			console.log(dateString);
			var today = new Date();
			var birthDate = new Date(dateString);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		getColors(length, alpha) {
			var all = [
				{ r: 48, g: 172, b: 214 },
				{ r: 17, g: 70, b: 115 },
				{ r: 68, g: 210, b: 60 },
				{ r: 229, g: 66, b: 84 },
				{ r: 194, g: 136, b: 91 },
				{ r: 90, g: 49, b: 249 },
				{ r: 130, g: 136, b: 36 },
				{ r: 247, g: 59, b: 209 },
				{ r: 215, g: 198, b: 6 },
				{ r: 117, g: 138, b: 131 },
				{ r: 25, g: 50, b: 173 },
				{ r: 55, g: 160, b: 122 }
			];

			return all.map(
				color =>
					"rgba(" +
					color.r +
					"," +
					color.g +
					"," +
					color.b +
					"," +
					alpha +
					")"
			);
		},
		getRandomInt(min = 0, max = 100) {
			return Math.floor(Math.random() * (max - min + 1)) + min;
		}
	}
};
</script>